import { EventTypes } from '@candulabs/craft';
import React from 'react';

import { useEditorSelector, useSelection } from 'craft/hooks';

import { NodeLabel } from './NodeLabel';

export const NodeLabels = React.memo(() => {
  const { selection } = useSelection();
  const draggedOver = useEditorSelector((state) => state.events[EventTypes.draggedOver]);

  if (selection.isEmpty && draggedOver.size === 0) {
    return null;
  }

  // don't render both labels while dragging
  const renderLabels = draggedOver.size === 0 ? selection.all : [...draggedOver];
  return (
    <>
      {renderLabels.map((nodeId: string) => (
        <NodeLabel key={nodeId} nodeId={nodeId} />
      ))}
    </>
  );
});
